"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tool_1 = require("./tool");
const systemUrls = require("../config/service-urls.json");
const defaultSystem = 'live';
function getConfig(defaultValues) {
    let system = tool_1.getSearchQueryVariable('system', defaultSystem);
    if (!systemUrls[system]) {
        system = defaultSystem;
    }
    return {
        mapServiceUrl: tool_1.getSearchQueryVariable('mapServiceUrl', defaultValues.mapServiceUrl || systemUrls[system].mapServiceUrl),
        routeServiceUrl: tool_1.getSearchQueryVariable('routeServiceUrl', defaultValues.routeServiceUrl || systemUrls[system].routeServiceUrl),
        projectName: tool_1.getSearchQueryVariable('projectName', defaultValues.projectName || 'mathematikon_basemap'),
        lang: tool_1.getSearchQueryVariable('language', defaultValues.language || 'de')
    };
}
exports.getConfig = getConfig;
